import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import '../website-mobile/theme.css';
import Topbar from '../components/shared/TopBar/Topbar';
import Page1 from './components/Page1/page1';
import Page2 from './components/Page2/page2';
import Page3 from './components/Page3/page3';
import Page4 from './components/Page4/page4';
import Page5 from './components/Page5/page5';
import Page6 from './components/Page6/page6';
import Page7 from './components/Page7/page7';
import Page8 from './components/Page8/page8';
import Page9 from './components/Page9/page9';
import Footer from '../website-mobile/components/Footer/Footer';

/**
 * DesktopPage — full desktop landing experience.
 * commonBg is applied here ONCE so all pages share a seamless background.
 * Lazy loading: only Page1 loads initially, others load on scroll via useInView.
 */
const LazyPageWrapper = ({ children, pageNum }) => {
    const { ref, inView } = useInView({ threshold: 0.1 });
    const [loaded, setLoaded] = useState(pageNum === 1);

    useEffect(() => {
        if (inView && !loaded) {
            setLoaded(true);
        }
    }, [inView, loaded]);

    return (
        <div ref={ref}>
            {loaded ? children : <div style={{ minHeight: '100vh' }} />}
        </div>
    );
};

export default function DesktopPage({ handleBtnClick }) {
    useEffect(() => {
        const prevHtml = document.documentElement.style.overflowX;
        const prevBody = document.body.style.overflowX;

        document.documentElement.style.overflowX = 'clip';
        document.body.style.overflowX = 'clip';

        return () => {
            document.documentElement.style.overflowX = prevHtml;
            document.body.style.overflowX = prevBody;
        };
    }, []);

    return (
        <>
            <Topbar handleBtnClick={handleBtnClick} />
            <div
                style={{
                    width: '100%',
                    overflowX: 'clip',
                }}
            >
                <Page1 handleBtnClick={handleBtnClick} />
                <LazyPageWrapper pageNum={2}><Page2 /></LazyPageWrapper>
                <LazyPageWrapper pageNum={3}><Page3 handleBtnClick={handleBtnClick} /></LazyPageWrapper>
                <LazyPageWrapper pageNum={4}><Page4 handleBtnClick={handleBtnClick} /></LazyPageWrapper>
                <LazyPageWrapper pageNum={5}><Page5 /></LazyPageWrapper>
                <LazyPageWrapper pageNum={6}><Page6 /></LazyPageWrapper>
                <LazyPageWrapper pageNum={7}><Page7 /></LazyPageWrapper>
                <LazyPageWrapper pageNum={8}><Page8 handleBtnClick={handleBtnClick} /></LazyPageWrapper>
                <LazyPageWrapper pageNum={9}><Page9 /></LazyPageWrapper>
                <LazyPageWrapper pageNum={10}><Footer /></LazyPageWrapper>
            </div>
        </>
    );
}
